import { render, staticRenderFns } from "./cookie-declaration.vue?vue&type=template&id=55aa0241&"
import script from "./cookie-declaration.vue?vue&type=script&lang=js&"
export * from "./cookie-declaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports